import type { ConfigSection, GameProfile, Menu, ProfileCtx } from "./types";
import defaultProfile from "@/game_profiles/default";
import { commonMenuItems } from "@/game_profiles/common";

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "basic" } },
  { component: "ConfSection", props: { name: "extended" } },
  { component: "TableSection", props: { name: "permittedList" } },
  { component: "TableSection", props: { name: "bannedList" } },
];

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
});
